if (!customElements.get('tab-head')) {
  class TabHead extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleUpdateTabHeadRef = this.handleUpdateTabHead.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      const anchor = event.target.closest('a');
      if (!anchor) return;

      const anchorIndex = anchor.getAttribute('data-index');

      this.querySelectorAll('.js-tab-anchor').forEach((item) => {
        item.parentElement.classList.toggle(
          'is-open',
          item.getAttribute('data-index') == anchorIndex,
        );
      });

      document.dispatchEvent(
        new CustomEvent('exo:toggle-tab', {
          detail: { id: this.getAttribute('data-id'), index: anchorIndex },
        }),
      );
    }

    handleUpdateTabHead(event) {
      this.querySelectorAll('a')[event.detail.index - 1].click();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
      document.removeEventListener(
        'exo:update-tab-head',
        this.handleUpdateTabHeadRef,
      );
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
      document.addEventListener(
        'exo:update-tab-head',
        this.handleUpdateTabHeadRef,
      );
    }
  }

  customElements.define('tab-head', TabHead);
}
